import { useContext } from 'react'

import { AuthContext } from './AuthContext'

/**
 * Consumer hook for the AuthProvider. Throws if used outside the provider —
 * indicates the component tree is mis-mounted, not a runtime user issue.
 */
export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>')
  return ctx
}
